

import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

export default function SuggestedPost({ idCategory, postId, apiName }) {
   const [posts, setPosts] = useState([]);
  const isMobile = window.innerWidth <= 768;

  function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

   useEffect(() => {
  let cancelled = false;

  const fetchData = async () => {
    try {
      const res = await axios.get(apiName);

      const currentId = Number(postId);

      const filtered = res.data
        .filter((p) => p.Stato === 1)
        .filter((p) => p.IdCategory === idCategory)
        .filter((p) => p.Id !== currentId);

      // Sort by relevance score
      const sorted = filtered.sort(
        (a, b) => (b.Rel + b.Share) - (a.Rel + a.Share)
      );

      // Take a larger pool, then randomize within it
      const pool = sorted.slice(0, 12); // tune 8–20
      const limit = window.innerWidth <= 768 ? 2 : 3;
      const picked = shuffle(pool).slice(0, limit);

      if (!cancelled) setPosts(picked);
    } catch (err) {
      console.log(err);
    }
  };

  fetchData();
  return () => { cancelled = true; };
}, [idCategory, postId, apiName]);

  return (
    <>
      {posts.length > 1 && (
        <h2 className="text-2xl font-semibold mb-10">
          Altri articoli che ti potrebbero piacere...
        </h2>
      )}
      <div className="flex justify-center items-center lg:items-start lg:flex-row flex-col lg:space-x-10">
        {posts
        .filter(post => post.Stato === 1)
        .map((post) => {
            return (
                <Link to={`/notizie/${post.RewriteUrl}/`} key={post.Id}>
                  <div className="flex flex-col justify-center align-center grayscale hover:grayscale-0 transition duration-1000 ease-in- w-72">
                    <img
                      src={post.ImgCopertina}
                      alt={post.Titolo}
                      className="w-full object-contain mb-4"
                    />
                    <h2 className="text-lg font-semibold mb-2">
                      {post.Titolo}
                    </h2>
                    <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                      {post.Subtitle}
                    </p>
                  </div>
                </Link>
            );
          }
        )}
      </div>
    </>
  );
}